export enum FcdEncodingStatusType {
  CORRECT = 'correct',
  ERROR = 'error',
  MANUAL = 'manual',
  NOTROUTABLE = 'notroutable'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/fcdencodingstatustype.ts